module.exports = __webpack_public_path__ + "img/tree-black.a33f570a.svg";